import React, { useState } from 'react';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import MainPageTitle from '../../designComponents/titles/MainPageTitle';
import { ExcelButton } from '../../designComponents/buttons/Buttons';
import { Wrapper02 } from '../../designComponents/wrappers/FlexMainWrapper';
import { onClickExcelFormat } from '../../data_system/xlsx_util/xlsx_util';

const UserAccountExcelPage = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);

    const onDownloadExcel = async () => {
        if (!startDate || !endDate) {
            alert('시작일과 종료일을 선택해 주세요.');
            return;
        }

        if (new Date(startDate) > new Date(endDate)) {
            alert('시작일은 종료일보다 늦을 수 없습니다.');
            return;
        }

        try {
            setLoading(true);
            const response = await RefreshCheckApi.get('/adminStatus/user-account/excel', {
                params: { startDate, endDate },
            });

            const rows = response?.data?.data || [];
            if (!rows.length) {
                alert('조회된 데이터가 없습니다.');
                return;
            }

            const headers = Object.keys(rows[0]);
            const body = rows.map((row) => headers.map((key) => row[key] ?? ''));
            const fileName = `회원정보_${startDate}_${endDate}.xlsx`;
            onClickExcelFormat(headers, body, fileName);
        } catch (e) {
            alert('엑셀 다운로드 중 오류가 발생했습니다.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Wrapper02>
            <MainPageTitle text={'회원 정보 엑셀'} />
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '18px' }}>
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                <span>~</span>
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                <ExcelButton text={loading ? '조회중...' : 'Excel 다운로드'} onClick={onDownloadExcel} width={120} />
            </div>
        </Wrapper02>
    );
};

export default UserAccountExcelPage;
